export enum ColumnType {
  name = "name",
  address = "address",
  lastVisit = "lastVisit",
  wcpid = "wcpid",
}

export const columnLabels = Object.values(ColumnType);
